import React, { useState } from "react";
import { ModalBody } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { getAddsOneGroup, postAddsOne, postAddsOneGroup } from "../../../MyApi/addsone";
import { toast } from "react-toastify";
import AddIcon from "../../Common/svg/addicon";
import EnhancedSearchProduct from "../../UI/enhancedproductsearch";
import { formatPrice } from "../../../utils/formatPrice";

const AddsOneModal = ({ isOpen, closeModal ,refetch  ,store_id ,setSelectedAddOnsGroup  ,setGroupsState, product }) => {
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    applicable_to:"product",
    group_id:""
  });
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [isLinkedToProduct, setIsLinkedToProduct] = useState(false);
  const [linkedProductId, setLinkedProductId] = useState("");
  const [linkedProductName, setLinkedProductName] = useState("");
 const {data, refetch: refetchGroups}=useQuery(["getAddsonegroup", store_id], () => getAddsOneGroup(store_id));
  const mutation = useMutation({
    mutationKey: ["postAdds"],
    mutationFn: (postData) => postAddsOne(postData),

    onSuccess: (data) => {
      const groupId = formData.group_id; 
       const newAddon = data.data.add_on;
const newAddonArray = {
  ...newAddon,
  selected: true,
  price: formatPrice(product.currency_factor, newAddon.price),
};
       toast.success(`${data.message}`)
      // امسح البيانات بعد نجاح الإضافة
      setFormData({ name: "", price: "" });
       refetch()
       refetchGroups();

console.log('groupId', newAddon)


  setGroupsState((prev) => ({
    ...prev,
    [groupId]: {
      ...prev[groupId],
      add_ons: [...(prev[groupId]?.add_ons || []), newAddonArray  ],
    },
  }));

setSelectedAddOnsGroup((prev) =>
{
  console.log('prev', prev)
const updatedAddOns =  prev.map((group) => {
    if (group.id === Number(groupId)) {
      return {
        ...group,
        add_ons: [...group.add_ons,  newAddonArray ],
      };
    }
    return group;
  })
  return updatedAddOns
}
  )
      // اقفل المودال
      closeModal();
    },onError:(error)=>{
      toast.error(`${error.response.data.message}`)
    }
  });

 const addsOneGroup = data?.data?.add_on_groups || [];
   const handleChange = (e) => {
     const { name, value } = e.target;
     setFormData((prev) => ({
       ...prev,
       [name]: value,
     }));
   };

   const handleLinkedProductChange = (e) => {
     const checked = e.target.checked;
     setIsLinkedToProduct(checked);
     if (checked) {
       setFormData((prev) => ({ ...prev, name: "" }));
       setLinkedProductId("");
     }
   };

   const handleProductSelect = (productId ,productName) => {
     setLinkedProductId(productId);
     setLinkedProductName(productName);
   };

   const handleAddPostRequest = () => {
     const postData = {
       price: formData.price,
       applicable_to: "product",
       store_id,
       add_on_group_id: formData.group_id
     };

     if (isLinkedToProduct && linkedProductId) {
       postData.linked_product_id = linkedProductId;
     } else {
       postData.name = formData.name;
     }

     mutation.mutate(postData);
   };

  // Mutation for creating addon group
  const groupMutation = useMutation({
    mutationKey: ["postAddsOneGroup"],
    mutationFn: (postData) => postAddsOneGroup(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      setGroupName("");
      setIsGroupModalOpen(false);
      refetchGroups();
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response?.data?.message || 'حدث خطأ'}`);
    }
  });

  const handleCreateGroup = () => {
    if (!groupName.trim()) {
      toast.error("الرجاء إدخال اسم المجموعة");
      return;
    }
    groupMutation.mutate({
      name: groupName,
      store_id: store_id,
      is_active: 1
    });
  };

  const openGroupModal = () => setIsGroupModalOpen(true);
  const closeGroupModal = () => {
    setIsGroupModalOpen(false);
    setGroupName("");
  };

  return (
    <Modal isOpen={isOpen} toggle={closeModal}>
      <ModalHeader>
        إضافة إضافات للمنتج
      </ModalHeader>
      <ModalBody>
        <div className="row add">
           <div className="col-12">
             <div className="form-check mb-3">
               <input
                 type="checkbox"
                 className="form-check-input"
                 id="linkedToProduct"
                 checked={isLinkedToProduct}
                 onChange={handleLinkedProductChange}
               />
               <label className="form-check-label" htmlFor="linkedToProduct">
                 اختيار من منتج
               </label>
             </div>

             {isLinkedToProduct ? (
               <div>
                 <label className="form-label">اختر المنتج</label>
                 <EnhancedSearchProduct
                   storeId={store_id}
                   setProductId={handleProductSelect}
                   value={linkedProductId ? { id: linkedProductId ,name: linkedProductName} : null}
                 />
               </div>
             ) : (
               <div>
                 <label className="form-label">اسم الإضافة</label>
                 <input
                   type="text"
                   name="name"
                   className="form-control"
                   value={formData.name}
                   onChange={handleChange}
                 />
               </div>
             )}
           </div>

          <div className="col-12 mt-3">
            <label className="form-label">سعر الإضافة</label>
            <input
              type="number"
              name="price"
              className="form-control"
              value={formData.price}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mt-3">
            <div className="d-flex align-items-center gap-2">
              <label className="form-label mb-0">مجموعة الإضافات</label>
              <button className="btn btn-primary btn-sm p-1" onClick={openGroupModal} type="button">
                <AddIcon />
              </button>
            </div>
            <select className="form-control" name="group_id" value={formData.group_id} onChange={handleChange}>
              <option value="product">إضافات خاصة بالمنتج</option>
              {
                addsOneGroup.map((group) => (
                  <option key={group.id} value={group.id}>{group.name}</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleAddPostRequest}
            disabled={mutation.isLoading}
          >
            {mutation.isLoading ? "جاري الإضافة..." : "تأكيد الإضافة"}
          </button>

          <button type="button" className="btn btn-white"  onClick={closeModal}>
            إلغاء
          </button>
        </div>
      </ModalBody>

      {/* Modal for creating new addon group */}
      <Modal isOpen={isGroupModalOpen} toggle={closeGroupModal}>
        <ModalHeader toggle={closeGroupModal}>
          إضافة مجموعة إضافات جديدة
        </ModalHeader>
        <ModalBody>
          <div className="col-12">
            <label className="form-label">اسم المجموعة</label>
            <input
              type="text"
              className="form-control"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="أدخل اسم المجموعة"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleCreateGroup}
            disabled={groupMutation.isLoading}
          >
            {groupMutation.isLoading ? "جاري الإضافة..." : "تأكيد الإضافة"}
          </button>
          <button type="button" className="btn btn-white" onClick={closeGroupModal}>
            إلغاء
          </button>
        </ModalFooter>
      </Modal>
    </Modal>
  );
};

export default AddsOneModal;
